import { MarketAppView } from 'domain/entity/market/marketApp';
import ReadMarketAppsCriteria from 'use-case/marketApps/read/readMarketAppsCriteria';
import { getArrayApiClient } from 'adapter/out/client/apiClient';

const asMarketApps = (marketAppJson: MarketAppJson): MarketAppView[] =>
    marketAppJson.flatMap((marketApp) =>
        marketApp.views.map((view: MarketAppViewJson) => new MarketAppView(view.id, view.key, view.title))
    );

export default getArrayApiClient(
    (criteria: ReadMarketAppsCriteria) => `apps-market/apps?visibility=${criteria.visibility}&installed=true`,
    MarketAppView,
    undefined,
    asMarketApps
);

type MarketAppJson = {
    views: MarketAppViewJson[];
}[];

type MarketAppViewJson = {
    id: number;
    resourceKey: string;
    title: string;
    url: string;
    visibility: string;
    key: string;
};
